// extracted by mini-css-extract-plugin
module.exports = {"form":"NewTodo_form__3foEh"};